import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function findAllAnimalsForMovement(payload) {
  const {
    groupId,
    farmId,
    page,
    size,
    filters,
    sorter,
    withoutPagination,
    justIds,
    ids,
  } = payload;

  const baseUrl = `/bovexo/${groupId}/farms/${farmId}/movement/animals/list`;

  if (justIds != null && justIds === true) {
    return apiAnimals.post(
      `${baseUrl}?justIds=true${
        filters !== "" && filters != null ? `&search=${filters}` : ""
      }`,
      null,
      getHeaders(false, null)
    );
  } else if (withoutPagination != null && withoutPagination === true) {
    if (ids != null) {
      return apiAnimals.post(
        `${baseUrl}?withoutPagination=true`,
        ids,
        getHeaders(false, null)
      );
    }
    return apiAnimals.post(
      `${baseUrl}?withoutPagination=true`,
      null,
      getHeaders(false, null)
    );
  } else {
    let field = null;
    let order = null;

    if (sorter) {
      let { field: fieldSorter, order: orderSorter } = sorter;

      field =
        fieldSorter === "handlingNumber"
          ? "handling_number"
          : fieldSorter === "lastDailyWeight"
          ? "last_daily_weight"
          : fieldSorter;

      order = orderSorter === "descend" ? "DESC" : "ASC";
    }

    return apiAnimals.post(
      `${baseUrl}?withoutPagination=false${page ? `&page=${page - 1}` : ""}
        ${
          sorter != null && Object.entries(sorter).length > 0
            ? `&sort=${field}&direction=${order}`
            : ""
        }
        ${size && `&size=${size}`}
        ${filters !== "" && filters != null ? `&search=${filters}` : ""}`,
      null,
      getHeaders(false, null)
    );
  }
}

export function saveMovementAnimals(payload) {
  const { groupId, farmId, body } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/movement/animals`,
    body,
    getHeaders()
  );
}
